/**
 * Created by vladislav on 04/04/2022
 */

const Caravan = function (mission) {
    this.mission = mission;
};

Caravan.prototype.buyProduct = function (product) {
    cleverapps.paymentsLogic.giveReward(product.reward);
};

Caravan.prototype.customSpawn = function () {
    const unit = Map2dLocation.currentLocation.shipsPlanner.spawnUnit();
    if (!unit) {
        return;
    }

    const ship = unit.findComponent(Ship);
    if (ship) {
        ship.onCustomSpawn(cc.ScrollAction.SCROLL_TO_DURATION);
    }
};

Caravan.prototype.beforeRemove = function (f) {
    if (typeof Map2dLocation !== "undefined") {
        Map2dLocation.currentLocation.shipsPlanner.removeUnit();
    }

    f();
};